import { useNavigate } from 'react-router'
import { FaArrowLeft } from 'react-icons/fa'

import Filler from '../utils/Filler'

interface Props {
  title: string
}

const NotAvailable: React.FC<Props> = ({ title }) => {
  const navigate = useNavigate()
  return (
    <div className="border-theme relative flex h-dvh w-full max-w-[600px] grow flex-col border">
      <div className="border-theme sticky top-0 left-0 z-[80] flex h-[60px] w-full items-center border-b bg-inherit pl-[10px] text-xl font-bold">
        <button
          onClick={() => {
            navigate('/home', { replace: true })
          }}
          className="hover-main flex h-[40px] w-[40px] items-center justify-center rounded-full text-sm"
        >
          <FaArrowLeft />
        </button>
        <p className="pl-[20px] tracking-wide">{title}</p>
      </div>
      <Filler />
      <div className="text-sub flex h-full w-full items-center justify-center px-[50px]">
        <h1>{`'${title}' is not yet an available feature in this version of the app.`}</h1>
      </div>
    </div>
  )
}

export default NotAvailable
